export const AnimalWeightOptions = {
    SINGLE: 1,
    TOTAL: 2
};